import { IAccount } from '../access-management/account-dto';
import { IUser } from '../access-management/user-dto';
import { AvailablePsp } from '../../pages/private/components/psp-select';

export enum KeyEncryptionType {
    TDES192 = 'TDES-192',
    RSA4096 = 'RSA-4096',
    AES128 = 'AES-128'
}

export enum KeyType {
    BDK = 'pspMasterKey',
    LHMAC = 'pspListKey',
    KSID = 'ksid',
    KEY_TABLE_KEY = 'keyTableKey',
    TRANSPORT_KEY = 'transportKey',
}

export enum KCVType {
    TRANSPORT_KEY = 'kcvTransportKey',
    BDK = 'kcvBDK',
    LHMAC = 'kcvListHMAC',
    KSID = 'ksid',
    KEY_TABLE_KEY = 'kcvKeyTableKey',
    KERNEL_CONFIG = 'kcvKernelConfig',
    KEY_TABLE = 'kcvKeyTable',
}

export enum PSP {
    LittlePay = 'LittlePay',
    Pulse = 'Pulse',
    Unicard = 'Unicard',
    Vault = 'Vault',
    ExternalKeyManager = 'ExternalKeyManager',
}

export enum KeyInputType {
    ENCRYPTED_VALUE = 'encryptedValue',
    X9_143_KEY_BLOCK = 'keyBlock'
}

export interface IKeyTypeSupport {
    name: string;
    label: string;
    distributable?: boolean;
}
export interface IKeyTypeSupportMapped {
    [key: string]: IKeyTypeSupport[];
}

export interface IClientKey {
    id: number;
    keyName: string;
    keyType: string;
    status?: string;
    psp?: PSP;
    dateUploaded: Date | string;
}

export interface ICustomerKey extends IClientKey {
    user: IUser;
    varAccount: IAccount;
    clientAccount: IAccount;
}

export interface IUploadCustomerKeyOptions {
    varAccountId: number;
    clientAccountId: number;
    psp: string;
    keyName: string;
    uploadKeys: IUploadKeyOptions[];
}
export interface IUploadCustomerKeyResponse {
    created: boolean;
    errorMessages?: string[];
}
export interface IUploadKeyOptions {
    type: KeyType;
    content: string;
    inputType?: KeyInputType;
}

export interface IDistributeKeyRequestOptions {
    varId?: number;
    clientId?: number;
    deviceIdentifier?: string;
    deviceGroupName?: string;
    deviceGroupNames?: string[];
    psps?: AvailablePsp[];
}

export interface IDistributeKeyResponseResult {
    identifier: string;
    status: 'success' | 'warning' | 'fail';
    errors?: string[];
}
export interface IClientPspEncryptionType {
    pspType: PSP;
    encryptionType: KeyEncryptionType;
}
export class KcvPspKeyDto {
    constructor(private readonly _object: unknown = {}) {
    }

    get kcvTransportKey(): string {
        return this._object['kcvTransportKey'] || 'N/A';
    }

    get ksid(): string {
        return this._object['ksid'] || 'N/A';
    }

    get kcvBDK(): string {
        return this._object['kcvBDK'] || 'N/A';
    }

    get kcvListHMAC(): string {
        return this._object['kcvSHA1ListHMAC'] || this._object['kcvListHMAC'] || 'N/A';
    }

    get kcvCmacListHMAC(): string {
        return this._object['kcvCmacListHMAC'] || 'N/A';
    }

    get kcvKeyTableKey(): string {
        return this._object['kcvKeyTableKey'] || 'N/A';
    }

    get kcvKernelConfig(): string {
        return this._object['kcvKernelConfig'] || 'N/A';
    }

    get kcvKeyTable(): string {
        return this._object['kcvKeyTable'] || 'N/A';
    }
}
